/**
 * @generated SignedSource<<c8e9233dd995c680593c0ace2a74f178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakeholderDistributionSetInputObject = {
  distribution: boolean;
  stakeholderId: string;
};
export type ownerDistributionsRow_ToggleMutation$variables = {
  input: StakeholderDistributionSetInputObject;
};
export type ownerDistributionsRow_ToggleMutation$data = {
  readonly stakeholderDistributionSet: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly distribution: boolean;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ownerDistributionsRow_ToggleMutation = {
  response: ownerDistributionsRow_ToggleMutation$data;
  variables: ownerDistributionsRow_ToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distribution",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ownerDistributionsRow_ToggleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakeholderDistributionSetMutationPayload",
        "kind": "LinkedField",
        "name": "stakeholderDistributionSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ownerDistributionsRow_ToggleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakeholderDistributionSetMutationPayload",
        "kind": "LinkedField",
        "name": "stakeholderDistributionSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48686b562b04b57e5325e95ba3577252",
    "id": null,
    "metadata": {},
    "name": "ownerDistributionsRow_ToggleMutation",
    "operationKind": "mutation",
    "text": "mutation ownerDistributionsRow_ToggleMutation(\n  $input: StakeholderDistributionSetInputObject!\n) {\n  stakeholderDistributionSet(input: $input) {\n    stakeholder {\n      id\n      distribution\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "12c710041b4a4d57a5e28b9e99a538f4";

export default node;
